import 'nodelist-foreach-polyfill';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { ScrollSmoother } from "gsap/ScrollSmoother.js";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import imagesLoaded from "imagesloaded";

import Scroller from './modules/_scroller.js';
import Misc from './modules/_misc.js';
import HoverRoll from './modules/_hoverRoll.js';
import Transition from './modules/_transition.js';
import Header from './modules/_header.js';
import Footer from './modules/_footer.js';
import PageCover from './modules/_pagecover.js';
import Features from './modules/_features.js';
import VerticalGallery from './modules/_verticalGallery.js';
import ContentSection from './modules/_contentsection.js';
import SidePane from './modules/_sidepane.js';
import SideAccordion from './modules/_sideaccordion.js';
import StickyReserveNav from './modules/_stickyReserveNav.js';
import Carousel from './modules/_carousel.js';

import Index from './modules/_index.js';
import Wedding from './modules/_wedding.js';
import Topics from './modules/_topics.js';
import Party from './modules/_party.js';
import Contact from './modules/_contact.js';

class App {
	constructor() {
		window.gsap = gsap;
		window.ScrollSmoother = ScrollSmoother;
		window.ScrollTrigger = ScrollTrigger;
		window.ScrollToPlugin = ScrollToPlugin;
		gsap.registerPlugin(ScrollSmoother, ScrollTrigger, ScrollToPlugin);
		ScrollTrigger.config({ 
			ignoreMobileResize: true
		});

		this.Scroller = new Scroller();
		window.globalScroller = this.Scroller;
		this.Misc = new Misc();
		this.HoverRoll = new HoverRoll();
		this.Transition = new Transition();
		this.Header = new Header();
		this.Footer = new Footer();
		this.PageCover = new PageCover();
		this.Features = new Features();
		this.VerticalGallery = new VerticalGallery();
		this.ContentSection = new ContentSection();
		this.SidePane = new SidePane();
		this.SideAccordion = new SideAccordion();
		this.StickyReserveNav = new StickyReserveNav();
		this.Carousel = new Carousel();
		
		this.Index = new Index();
		this.Wedding = new Wedding();
		this.Topics = new Topics();
		this.Party = new Party();
		this.Contact = new Contact();
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const resizeHandler = ()=>{
		const vw = document.body.clientWidth;
		window.vw = vw;
		document.documentElement.style.setProperty('--vw', vw+'px');

		const ruler = document.createElement("div");
		ruler.style.height = "100lvh";
		ruler.style.position = "fixed";
		document.body.append(ruler);
		const lvh = ruler.offsetHeight;
		ruler.remove();
		window.lvh = lvh;
	}
	document.documentElement.classList.add("vwready");
	window.addEventListener("resize", resizeHandler, false);
	resizeHandler();

	let contextChangeEvent = null;
	if(document.documentMode){
		contextChangeEvent = document.createEvent('Event');
		contextChangeEvent.initEvent('contextChange', true, true);
	}else{
		contextChangeEvent = new Event('contextChange');
	}
	window.currentContext = (document.body.clientWidth < 767) ? "sp" : "pc";
	window.addEventListener("resize", ()=>{
		const context = (document.body.clientWidth < 767) ? "sp" : "pc";
		if(window.currentContext != context){
			window.currentContext = context;
			window.dispatchEvent(contextChangeEvent);
			location.reload();
		}
	}, false);

	window.rpx = (num, ctx)=>{
		if(!ctx) ctx = window.currentContext;
		return num * window.vw / ((ctx=="pc"?1440:375));
	}

	window.isTouch = false;
	if( document.ontouchstart !== undefined ) {
		window.isTouch = true;
		document.body.classList.add('touch');
	}
	let app = new App();

	let fontReady = false;
	let imageReady = false;
	const siteReadyEvent = new Event('siteready');
	const preparing = ()=>{
		if(fontReady && imageReady && !document.body.classList.contains("siteReady")){
			document.body.classList.add("siteReady");
			window.dispatchEvent(siteReadyEvent);
		}
	} 

	const preloadTargets = [
		".preload", ".preload *"
	];
	const preloadimages = document.querySelectorAll(preloadTargets.join(","));
	const loader = imagesLoaded( preloadimages );
	loader.on("always", ()=>{
		imageReady = true;
		preparing();
	});

	const rootClassObserver = new MutationObserver(records => {
		if(
			(	document.documentElement.classList.contains("wf-fot-cezanne-pron-n5-active") &&
				document.documentElement.classList.contains("wf-dnp-shuei-mincho-pr6n-n5-active") &&
				document.documentElement.classList.contains("wf-neue-haas-grotesk-text-n4-active") &&
				document.documentElement.classList.contains("wf-kudryashev-d-contrast-sans-n4-active")
			) ||
				document.documentElement.classList.contains("wf-inactive")
			){
			fontReady = true;
			preparing();
			rootClassObserver.disconnect();
		}
	});
	rootClassObserver.observe(document.documentElement, {
		attributes: true,
		attributeFilter: ['class']
	});
	setTimeout(()=>{
		// font load timeout
		if(fontReady == false){
			fontReady = true;
			preparing();
			rootClassObserver.disconnect();
		}
	}, 2000);

	document.scrollingElement.scrollTop = 0;
	if(history){
		if(history.scrollRestoration){
			history.scrollRestoration = "manual";
		}
	}
	window.addEventListener('pageshow', ()=>{
		document.documentElement.classList.remove("transit-ready");
		document.documentElement.classList.remove("transit");
	});
}, false);